import type { BaseComponentProps } from "@q4/nimbus-ui";
import { AgGridReact } from "ag-grid-react";
import React, { ReactNode } from "react";

export interface GridToolbarProps extends BaseComponentProps {
  userContext?: Record<string, unknown>;
  leftContent?: ReactNode;
  leftContentWidth?: string;
  rightContent?: ReactNode;
  rightContentWidth?: string;
  gridRef?: React.RefObject<AgGridReact>;
  disabled?: boolean;
  showDownloadDataButton?: boolean;
  showUploadDataButton?: boolean;
  showCapitalFlowButton?: boolean;
  uploadData?: () => void;
  downloadCapitalFlowData?: () => Promise<void>;
  downloadCapitalFlowDataLoading?: boolean;
}

export enum GridToolbarClassName {
  Base = "grid-toolbar",
  Grid = "grid-toolbar__grid",
  LeftColumn = "grid-toolbar__left-column",
  RightColumn = "grid-toolbar__right-column",
}
